// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__38Lcr","rootSuccess":"CompleteLink_rootSuccess__2fqdS","rootFailure":"CompleteLink_rootFailure__38p9Z","isDisabled":"CompleteLink_isDisabled__1Bbqz"};